namespace Ir.Components.ReportDesigner.ReportDesignerField {

    interface IViewModel {
        field: ReportField | MetricField;
        icon: KnockoutComputed<string>;
        icon2: string;
        color: KnockoutComputed<string>;
        increaseGroupIdButtonConfig: DevExpress.ui.dxButton.Properties;
        decreaseGroupIdButtonConfig: DevExpress.ui.dxButton.Properties;
        removeButtonConfig: DevExpress.ui.dxButton.Properties;
        restoreComparisonMetricsButtonConfig: DevExpress.ui.dxButton.Properties;
        settingsButtonConfig: DevExpress.ui.dxButton.Properties;
        editExpressionButtonConfig: DevExpress.ui.dxButton.Properties;
        changeAutogroupingButtonConfig: DevExpress.ui.dxDropDownButton.Properties;
        groupingTypeOptions: Array<any>;
        marginLeft: KnockoutComputed<number>;
    }

    export interface IParams {
        field: ReportField | MetricField;
        reportConfig: KnockoutObservable<ReportConfig>;
        widgetType: KnockoutObservable<WidgetType>;
        onRemove(field: ReportField | MetricField);
        onPropertiesHidden?: Function;
        metricArray: KnockoutObservable<KnockoutObservableArray<MetricField>>;
        onIncreaseGroupId(field: ReportField | MetricField);
        maxGroupId: KnockoutObservable<number>;
        hasComparisonFilters: KnockoutComputed<boolean>;
        onChange: Function;
        groupFields: KnockoutObservableArray<ReportField>;
        openingAsPopup: boolean;
        reportDesigner: Ir.Components.ReportDesigner.ReportDesigner.IViewModel;
    }

    export function getViewModel(this: IViewModel, params: IParams, componentInfo) {
        let self = this;
        if ((params as any).config) {
            params = (params as any).config;
        }

        self.field = params.field;
        self.icon2 = null;

        let reportConfig = params.reportConfig();
        /** Return field as MetricField */
        let metricField = self.field as MetricField;

        self.color = ko.computed(function () {
            if (self.field.isMetric && metricField.metricContainer.comparisonFilterId) {
                let comparisonFilter = reportConfig.comparisonFilters().find(x => x.id() === metricField.metricContainer.comparisonFilterId)
                return comparisonFilter.color();
            }
            else {
                return self.field.isMetric ?
                    (metricField.metricContainer.isExpression ? "#444444" : "#7a7a7a") :
                    (self.field.groupingType() === GroupingTypeEnum.GROUP_BY ? "#337ab7" : "#668aa2");
            }
        });

        self.icon = ko.computed(function () {
            let icon = "";
            if (self.field.isMetric) {
                switch (self.field.groupingType()) {
                    case GroupingTypeEnum.SUM:
                        icon = "functions";
                        break;
                    case GroupingTypeEnum.COUNT:
                        icon = "counter_1";
                        break;
                    case GroupingTypeEnum.MAX:
                        icon = "stat_1";
                        break;
                    case GroupingTypeEnum.MIN:
                        icon = "stat_minus_1";
                        break;
                    case GroupingTypeEnum.TSUM:
                        icon = "functions";
                        self.icon2 = "height";
                        break;
                    case GroupingTypeEnum.DSUM:
                        icon = "functions";
                        self.icon2 = "calculate";
                        break;
                    case GroupingTypeEnum.WDSUM:
                        icon = "functions";
                        self.icon2 = "calculate";
                        break;
                    case GroupingTypeEnum.WSUM:
                        icon = "functions";
                        self.icon2 = "function";
                        break;
                }
            }
            else {
                switch (self.field.dataType) {
                    case DataTypeEnum.BIT:
                    case DataTypeEnum.BOOL:
                    case DataTypeEnum.NUMBER:
                        icon = "speed_1_2";
                        break;
                    case DataTypeEnum.DATE:
                        icon = "calendar_today";
                        break;
                    case DataTypeEnum.DATE:
                    default:
                        icon = "match_case";
                        break;
                }
            }

            return icon;
        });

        self.removeButtonConfig = {
            stylingMode: 'contained',
            icon: "remove",
            hint: "Remove the field",
            height: 20,
            width: 20,
            onClick(e) {
                params.onRemove(self.field);
            },
        };

        self.settingsButtonConfig = {
            stylingMode: 'contained',
            text: "...",
            hint: "Settings",
            height: 20,
            width: 20,
            onClick(e) {
                Ir.Components.ReportDesigner.ReportDesigner.hidePopovers();
                Ir.Components.ReportDesigner.ReportFieldDesignerProperties.show({
                    field: self.field, 
                    widgetType: params.widgetType(), 
                    $target: params.openingAsPopup ? $(".field-type", componentInfo.element) : componentInfo.element, 
                    metricArray: params.metricArray(), 
                    groupingTypeOptions: self.groupingTypeOptions, 
                    onPropertiesHidden: params.onPropertiesHidden,
                    restoreComparisonMetricsVisible,
                    reportConfig: reportConfig,
                    groupFields: params.groupFields,
                    reportDesigner: params.reportDesigner
                });
            },
        };

        let restoreComparisonMetricsVisible = ko.computed(function() {
            return self.field.isMetric && params.hasComparisonFilters() && !metricField.metricContainer.isExpression && 
                metricField.metricContainer.comparisonType == ComparisonMetricType.None;
                //field.displayName() !== allMetricName
        });

        self.editExpressionButtonConfig = {
            stylingMode: 'contained',
            icon: "columnproperties",
            hint: "Edit Expression",
            height: 20,
            width: 20,
            visible: self.field.isMetric && metricField.metricContainer.isExpression,
            onClick(e) {
                Ir.Components.ReportDesigner.ReportDesigner.hidePopovers();
                Ir.Components.ReportDesigner.ExpressionEditor.show(metricField, params.metricArray, self.groupingTypeOptions, params.reportDesigner);
            },
        };

        self.restoreComparisonMetricsButtonConfig = {
            stylingMode: 'contained',
            icon: "revert",
            hint: "Restore comparison metrics",
            height: 20,
            width: 20,
            visible: restoreComparisonMetricsVisible as any,
            onClick(e) {
                Ir.Components.ReportDesigner.ReportDesigner.addComparisonMetrics(metricField, params.reportDesigner);
            },
        };

        self.changeAutogroupingButtonConfig = {
            icon: 'event',
            hint: "Change AutoGrouping",
            height: 20,
            width: 20,
            visible: self.field.dataType === DataTypeEnum.DATE && !params.reportConfig().isOriginalTemplate,
            dropDownOptions: {
                width: 90,
                onShowing(e) {
                    $(componentInfo.element).addClass("autogrouping-opened");
                },
                onHiding(e) {
                    $(componentInfo.element).removeClass("autogrouping-opened");
                },
            },
            displayExpr: '',
            keyExpr: 'id',
            items: [
                { id: AutoGroupingEnum.None, text: " " },
                { id: AutoGroupingEnum.ByDay, text: "Day" },
                { id: AutoGroupingEnum.ByWeek, text: "Week" },
                { id: AutoGroupingEnum.ByWeekNumber, text: "Week Number" },
                { id: AutoGroupingEnum.ByWeekOnly, text: "Week Only" },
                { id: AutoGroupingEnum.ByMonth, text: "Month" },
                { id: AutoGroupingEnum.ByMonthOnly, text: "Month Only" },
                { id: AutoGroupingEnum.ByQuarter, text: "Quarter" },
                { id: AutoGroupingEnum.ByQuarterOnly, text: "Quarter Only" },
                { id: AutoGroupingEnum.ByYear, text: "Year" }
            ],
            showArrowIcon: false,
            useSelectMode: true,
            selectedItemKey: self.field.autoGrouping as any,
            useItemTextAsTitle: false,
        };

        if (self.field.isMetric && metricField.metricContainer.isExpression) {
            self.groupingTypeOptions = allGroupingTypes.filter(x => x.forExpression);
        }
        else {
            self.groupingTypeOptions = allGroupingTypes.filter(x => x.enabled);
        }

        self.marginLeft = ko.computed(function() {
            return self.field.groupId() * 10;
        });

        self.increaseGroupIdButtonConfig = {
            stylingMode: 'contained',
            icon: "chevronright",
            hint: "Change group level",
            height: 20,
            width: 20,
            visible: ko.computed(function() {
                return !self.field.isMetric && (self.field.groupId() < params.maxGroupId());
            }) as any,
            onClick(e) {
                Ir.Components.ReportDesigner.ReportDesigner.hidePopovers();
                self.field.groupId(self.field.groupId() + 1);
                params.onIncreaseGroupId?.(self.field);
            },
        };

        self.decreaseGroupIdButtonConfig = {
            stylingMode: 'contained',
            icon: "chevronleft",
            hint: "Change group level",
            height: 20,
            width: 20,
            visible: ko.computed(function() {
                return !self.field.isMetric && (self.field.groupId() > 0);
            }) as any,
            onClick(e) {
                Ir.Components.ReportDesigner.ReportDesigner.hidePopovers();
                self.field.groupId(self.field.groupId() - 1);
                params.onIncreaseGroupId?.(self.field);
            },
        };
    }

    export let allGroupingTypes = [
        { value: GroupingTypeEnum.GROUP_BY, text: "Group By", enabled: true },
        { value: GroupingTypeEnum.MAX, text: "Max", enabled: true },
        { value: GroupingTypeEnum.MIN, text: "Min", enabled: true },
        { value: GroupingTypeEnum.SUM, text: "Sum", enabled: false },
        { value: GroupingTypeEnum.COUNT, text: "Count", enabled: true },
        { value: GroupingTypeEnum.WSUM, text: "WSum", enabled: false },
        { value: GroupingTypeEnum.DSUM, text: "Derived Sum", enabled: false, forExpression: true },
        { value: GroupingTypeEnum.WDSUM, text: "Derived Weight Sum", enabled: false, forExpression: true },
    ];
}